export const ZAZOS_FORMULAS_DOCS = 'https://help.zazos.com/pt-BR/collections/5367165-formulas';

export const ZAZOS_ACADEMY_LINK = 'https://help.zazos.com/pt-BR/';

export const SCHEDULE_DEMO_LINK = 'https://lp.zazos.com/demo';
